import { Text } from 'react-native-web';

export default function LoadingScreen() {
  return (
    <Text>Loading...</Text>
  )
}